import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import FlowSwitch from "./components/FlowSwitch";
import FlowStep from "./components/FlowStep";
export var recurseChildrenForFlowSteps = function recurseChildrenForFlowSteps(stepsArr, children) {
  if (!children) {
    return stepsArr;
  }

  React.Children.forEach(children, function (child) {
    if (! /*#__PURE__*/React.isValidElement(child)) {
      return;
    }

    if (child.type === FlowSwitch) {
      React.Children.forEach(child.props.children, function (switchChild) {
        if (switchChild.type === FlowStep) {
          var step = _objectSpread({}, switchChild.props);

          step.touched = false;
          stepsArr.push(step);
        }
      });
      return;
    }

    if (child.props.children) {
      recurseChildrenForFlowSteps(stepsArr, child.props.children);
    }
  });
  return stepsArr;
};